
import LottieWeb from "../services/LottieWeb.js"
import loadingIcon from "../assets/loadingSpinner.json"

export default {
  props: {
    spinnerText: {
      default: "",
      type: String
    }
  },
  async mounted() {
    const lottie = await LottieWeb.getLottieLight()
    this.anim = lottie.loadAnimation({
      container: this.$refs.soeAnimation,
      animType: "svg",
      loop: true,
      autoplay: false,
      animationData: loadingIcon
    })
    this.anim.setSubframe(false)
    this.anim.play()
  }
}
